import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './PasswordChangeForm.html?raw';
import Edit from '../Edit/Edit';
import '../Edit/Edit';
import PasswordCriteriaCheck from './PasswordCriteriaCheck';
import "./PasswordCriteriaCheck";
import { AccessibilityLabelsHelper, TranslationHelpers } from "../../../more/Helpers";
import "../Button/Button";

//import DataItems = require("DataItems");


class PasswordChangeForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private inputsContainer: HTMLElement;
    private validationResultContainer: HTMLElement;
    private messageContainer: HTMLElement;
    private txtActualUsername: HTMLElement;

    private oldPasswdContainer: HTMLElement;
    private passwordCriteriaCheck: MdsLax<InstanceType<typeof PasswordCriteriaCheck>>;
    private passwordChange_display_confirm: HTMLElement;
    private passwdConfirmationDisplay: HTMLElement;
    private errorMessageNode: HTMLElement;
    private displayError: HTMLElement;
    private displaySuccess: HTMLElement;

    private newPasswdInput: MdsLax<InstanceType<typeof Edit>>;
    private oldPasswdInput: MdsLax<InstanceType<typeof Edit>>;
    private newPasswdConfirmInput: MdsLax<InstanceType<typeof Edit>>;

    private oldPasswdInputLabel: HTMLElement;
    private newPasswdInputLabel: HTMLElement;
    private newPasswdConfirmInputLabel: HTMLElement;

    private _enableValidation = true;
    private useOldPassword: boolean = true;
    oldPasswd: string;
    newPasswd: string;
    private _isValid: boolean = false;


    private criteria: Partial<PasswordCriteria> = {
        isNumberRequired: true,
        lowercaseLetter: false,
        neededCriteriaCount: "all",
        passwordLength: 5,
        regexSpecial: /[!"§=*$%&/_\-()#{}?}{\[\]€@]+/,
        specialCharacters: false,
        uppercaseLetter: false
    };


    // DOM Events -----------------------------------------START

    // Hier passiert die Pattern Validierung, nur hier
    private _onChangeNewPassword(evt: Event): void {

        let inputValue = this.newPasswdInput.getValue();
        this.newPasswd = inputValue;

        this.validatePassword();

    }

    private _onChangeOldPassword(evt: Event): void {

        this.validatePassword();
    }

    private _onChangeConfirmPassword(evt: Event): void {

        this.displayMessage(null, false, null);

        this.validatePassword();
    }

    private _onFocus_newPasswordInputNode(evt: Event): void {
        if (this._enableValidation) this.UiModder.domClass.remove(this.validationResultContainer, "w3-hide");
    }

    private _onFocus_newPasswordConfirmInputNode(evt: Event): void {
        this.UiModder.domClass.remove(this.passwdConfirmationDisplay, "w3-hide");
    }

    private setValid(bool: boolean): void {

        if (bool != this._isValid) {
            this._isValid = bool !== false;
            this.emit("change", this._isValid);
            this.emit("valid", this._isValid);

        }
    }

    isValid(): boolean {
        return this._isValid;
    }

    getSubmitData(): PasswordSubmitData {
        let jsonData = {
            oldPassword: this.oldPasswd,
            newPassword: this.newPasswd,
            webuserId: window.sessionInfo.getCurrentWebuserId(true)
        };

        return jsonData;
    }

    private displayMessage(message: string, show: boolean, isException: boolean): void {

        if (show == true) {
            this.UiModder.domClass.remove(this.errorMessageNode, "w3-hide");
            if (isException == true) {
                this.UiModder.domClass.remove(this.displayError, "w3-hide");
                this.UiModder.domClass.add(this.displaySuccess, "w3-hide");

                this.displayError.innerHTML = message;


            } else {
                this.UiModder.domClass.add(this.displayError, "w3-hide");
                this.UiModder.domClass.remove(this.displaySuccess, "w3-hide");

                this.displaySuccess.innerHTML = message;
            }

            this.errorMessageNode.scrollIntoView({
                behavior: "smooth",
                block: "end",
            });

        } else {
            this.UiModder.domClass.add(this.errorMessageNode, "w3-hide");
        }


    }

    // DOM Events -----------------------------------------END

    private validatePassword(): void {
        this.oldPasswd = this.oldPasswdInput.getValue();

        let newValue = this.newPasswd;
        let oldValue = this.oldPasswd;

        if (!this.useOldPassword) oldValue = null;
        // beide Eingaben sind identisch?
        let bInputsMatch = false;
        if (newValue && newValue === this.newPasswdConfirmInput.getValue()) {
            bInputsMatch = true;
        }


        this.UiModder.domClass.toggle(this.passwordChange_display_confirm, "invalid", !bInputsMatch);
        this.UiModder.domClass.toggle(this.passwordChange_display_confirm, "valid", bInputsMatch);


        let pwValid = false;

        // neuer Wert ist alter Wert?
        if (oldValue && newValue && oldValue === newValue) {
            bInputsMatch = false;
            this.displayMessage(TranslationHelpers.tryTranslate("ChangeUserPassword_errorText_newPwdSameAsOld"), true, true);
        } else {
            if (oldValue != newValue) this.displayMessage(null, false, true);

            if (this._enableValidation) {
                if( newValue) this.hideNode(this.validationResultContainer, false);
                pwValid = this.passwordCriteriaCheck.validatePassword(oldValue, newValue);
            }
        }


        if (pwValid === true && bInputsMatch === true) {

            this.displayMessage(null, false, null);
            this.setValid(true);
        } else {
            this.setValid(false);
        }
    }




    private _setupValidationDisplay(): void {

        if (this.criteria) {
            if (this.criteria.isNumberRequired ||
                this.criteria.lowercaseLetter ||
                this.criteria.passwordLength > 0 ||
                (this.criteria.specialCharacters && this.criteria.regexSpecial) ||
                this.criteria.uppercaseLetter) {
                this._enableValidation = true;
            } else {
                this._enableValidation = false;
            }
        } else this._enableValidation = false;

        if (this._enableValidation) {
            this.passwordCriteriaCheck.setupRequirements(this.criteria)
        } else {
            this.hideNode(this.validationResultContainer);
        }

        this.hideNode(this.oldPasswdContainer, !this.useOldPassword);
        if (!this.useOldPassword) this.oldPasswd = null;
    }

    reset(): void {
        this.newPasswdInput.setValue("");
        this.newPasswd = null;
        this.newPasswdConfirmInput.setValue("");
        this.oldPasswdInput.setValue("");
        this.oldPasswd = null;
        this.validatePassword();

        this.hideNode(this.validationResultContainer);
        this.hideNode(this.passwdConfirmationDisplay);

    }
    // GEtters && Setters ---------------------------------------START

    setup(config: { customCriteria?: Partial<PasswordCriteria>, useOldPassword?: boolean }) {
        if (!config) return;

        if (config.customCriteria != undefined) {
            if (config.customCriteria == null) {
                this.criteria = null;
            } else {
                
                if (this.criteria == null) {
                    this.criteria = {
                        isNumberRequired: false
                    }
                }
                try {
                    // die vorhandenen properties aus den Kriterien übertragen:
                    for (let key in config.customCriteria) {
                        let val = config.customCriteria[key];

                        this.criteria[key] = val;
                    }
                } catch (ex) {

                }
            }

        } 

        if (config.useOldPassword != undefined) this.useOldPassword = config.useOldPassword == true;

        this._setupValidationDisplay();

    }

   
    // Getters && Setters ---------------------------------------END

    // Lifecycle ----------------------------------------------------------

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);


        if (this.hasFeature("PasswordChange")) {
            let feature = this.getModule<{
                settings: {
                    'lowercaseLetter': boolean,
                    'uppercaseLetter': boolean,
                    'isNumberRequired': boolean,
                    'specialCharacters': boolean,
                    'passwordLength': number,
                    'neededCriteriaCount': number,
                    'specialCharactersRegEx': RegExp
                }
            }>("PasswordChange");

            let pwCriteria: PasswordCriteria = {
                isNumberRequired: undefined,
                lowercaseLetter: undefined,
                neededCriteriaCount: undefined,
                passwordLength: undefined,
                regexSpecial: undefined,
                specialCharacters: undefined,
                uppercaseLetter: undefined
            };

            for (let setting in feature.settings) {
                let val = feature.settings[setting];
                switch (setting) {
                    case "lowercaseLetter":
                        pwCriteria.lowercaseLetter = val;
                        break;
                    case "uppercaseLetter":
                        pwCriteria.uppercaseLetter = val;
                        break;
                    case "isNumberRequired":
                        pwCriteria.isNumberRequired = val;
                        break;
                    case "specialCharacters":
                        pwCriteria.specialCharacters = val;
                        break;
                    case "passwordLength":
                        pwCriteria.passwordLength = val;
                        break;

                    case "specialCharactersRegEx":
                        pwCriteria.regexSpecial = val;
                        break;

                    case "neededCriteriaCount":
                        pwCriteria.neededCriteriaCount = val;
                        break;
                }
            }

            this.criteria = pwCriteria;

            AccessibilityLabelsHelper.LabelForInputBind(this.id, this.oldPasswdInput.domNode, "oldPasswdInput", this.oldPasswdInputLabel);
            AccessibilityLabelsHelper.LabelForInputBind(this.id, this.newPasswdInput.domNode, "newPasswdInput", this.newPasswdInputLabel);
            AccessibilityLabelsHelper.LabelForInputBind(this.id, this.newPasswdConfirmInput.domNode, "newPasswdConfirmInput", this.newPasswdConfirmInputLabel);
        }


        this.newPasswdInput.focusedValueChangeEmitterDelay = 20;
        this.newPasswdConfirmInput.focusedValueChangeEmitterDelay = 20;
        this.oldPasswdInput.focusedValueChangeEmitterDelay = 20;

        on(this.newPasswdInput, "focus", lang.hitch(this, this._onFocus_newPasswordInputNode));

        on(this.newPasswdConfirmInput, "focus", lang.hitch(this, this._onFocus_newPasswordConfirmInputNode));

        this._setupValidationDisplay();
        this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onSessionChange));
    }

    private _onSessionChange() {
        if (window.sessionInfo.isSessionOpen()) {
            this.UiModder.domAttr.set(this.txtActualUsername, "innerHTML", window.sessionInfo.getUserName(true));
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PasswordChangeForm);
